import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../../components/Layout';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { usersService } from '../../services/users.service';
import { adminsService } from '../../services/admins.service';
import { downloadCsv } from '../../utils/csv';

const Exports = () => {
  const { t } = useTranslation('common');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const exportUsers = async () => {
    setLoading(true);
    setError('');
    try {
      const users = await usersService.list();
      downloadCsv('users.csv', users as any);
    } catch (e: any) {
      setError(e?.message || 'Failed to export users');
    } finally {
      setLoading(false);
    }
  };

  const exportAdmins = async () => {
    setLoading(true);
    setError('');
    try {
      const admins = await adminsService.list();
      downloadCsv('admins.csv', admins as any);
    } catch (e: any) {
      setError(e?.message || 'Failed to export admins');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title={t('exports')}>
      <div className="space-y-4">
        {error && (
          <div className="p-3 rounded-md bg-red-50 text-red-600 border border-red-100">
            {error}
          </div>
        )}
        <Card className="p-4 space-y-3">
          <div className="flex items-center justify-between">
            <div className="font-medium">{t('users')}</div>
            <Button variant="primary" onClick={exportUsers} disabled={loading}>
              Export CSV
            </Button>
          </div>
          <div className="flex items-center justify-between">
            <div className="font-medium">{t('admins')}</div>
            <Button variant="primary" onClick={exportAdmins} disabled={loading}>
              Export CSV
            </Button>
          </div>
        </Card>
      </div>
    </Layout>
  );
};

export default Exports;

